
import Vue from 'vue'
import { CartItemViewModel } from '@ViewModels/CartItemViewModel'
import { Currency } from '@/components'
import QuantitySpinner from './QuantitySpinner.vue'

export default Vue.extend({
   name: 'ProductsInCartComponent',
   data() {
      return {
         submitted: false,
      }
   },
   computed: {
      cartItems(): CartItemViewModel {
         return this.$store.state.modelData.CartItems
      },
   },
   components: {
      Currency,
      QuantitySpinner,
   },
})
